import React from 'react';

class CompletionPercentage extends React.Component {
  render() {
    return (
      <div className="d-f ai-c jc-c mt-32 fz-bigger">
        <span className="mr-12">Assignment Completion Percentage</span>
        <div className="LearnerReviews-ratioBar m-0 w-150">
          <div
            className="LearnerReviews-ratio LearnerReviews-ratio--positive"
            style={{ width: this.props.completionPercentage }}
          />
        </div>
        <span className="ml-8">{this.props.completionPercentage}</span>
      </div>
    );
  }
}

export default CompletionPercentage;
